import {
	CoreAxiosInstanceV2,
	MutationConfig,
	QueryConfig,
	queryClient,
} from "@shared/config"
import { useMutation, useQuery } from "react-query"

import { IBaseFilterQuery } from "./../interfaces/base.interface"
import { ICreateTransaction } from "@shared/interfaces"
import { concatQuery } from "./../utils/util-function"

const END_POINT = `/transactionLogs/`

const TransactionLogServiceV2 = {
	NAME: "TransactionLogService",
	create(payload: ICreateTransaction): any {
		return CoreAxiosInstanceV2.post(`${END_POINT}`, payload)
	},
	deduct(payload: ICreateTransaction): any {
		return CoreAxiosInstanceV2.post(`${END_POINT}deductBalance`, payload)
	},
	filter(options: IBaseFilterQuery): any {
		return CoreAxiosInstanceV2.get(`${END_POINT}filter?${concatQuery(options)}`)
	},
}

export const useCreateTransactionLog = (
	config: MutationConfig<typeof TransactionLogServiceV2.create>
) => {
	const invalidQuery = `${TransactionLogServiceV2.NAME}${TransactionLogServiceV2.filter.name}`
	return useMutation({
		...config,
		mutationFn: TransactionLogServiceV2.create,
		onSettled: () => {
			queryClient.invalidateQueries(invalidQuery)
		},
	})
}

export const useDeductTransactionLog = (
	config: MutationConfig<typeof TransactionLogServiceV2.deduct>
) => {
	const invalidQuery = `${TransactionLogServiceV2.NAME}${TransactionLogServiceV2.filter.name}`
	return useMutation({
		...config,
		mutationFn: TransactionLogServiceV2.deduct,
		onSettled: () => {
			queryClient.invalidateQueries(invalidQuery)
		},
	})
}

export const useTransactionLogs = ({
	config,
	options,
}: {
	config?: QueryConfig<typeof TransactionLogServiceV2.filter>
	options?: IBaseFilterQuery
}) => {
	const queryName = `${TransactionLogServiceV2.NAME}${TransactionLogServiceV2.filter.name}`
	return useQuery({
		...config,
		queryKey: [queryName, Object.values(options)],
		queryFn: () => TransactionLogServiceV2.filter(options),
	})
}
